module.exports = __webpack_public_path__ + "img/icon-arrow-1.f040a2ac.svg";